import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUserVideoCoursesFeel, StateStatus } from '@guryou/redux';

const useUserVideoCourse = id => {
  const dispatch = useDispatch();
  const { data: rawData, status, version, entity } = useSelector(state => state.videoCourses.userVideoCoursesFeel);

  const [modifiedData, setModifiedData] = useState(null);

  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED) {
      dispatch(getUserVideoCoursesFeel());
    }
  }, [dispatch, status]);

  useEffect(() => {
    if (rawData) {
      const modified = rawData.map(item => ({
        ...item,
        description: window.DOMPurify.sanitize(item.description, { FORBID_ATTR: ['style'] }),
      }));
      setModifiedData(modified);
    }
  }, [rawData]);

  if (!id) {
    return { data: modifiedData, status, version, entity };
  }

  return { data: (modifiedData || []).find(x => x.id === id), status, version, entity };
};

export default useUserVideoCourse;
